export const getFilterForColors = (
  colorMode,
  colorString = '--theme-ui-colors-tertiary',
) => {
  const rootStyle = getComputedStyle(document.documentElement)
  const starColorHex =
    colorMode === 'default-product-1'
      ? '#FFDD04' // Pasta doesnt use tertiary color
      : colorMode === 'hey-hey-elote'
        ? '#FFFFBD'
        : rootStyle.getPropertyValue(colorString)

  const starColorFilter = {
    '#FF2815': '', // Cheddy , Down, Truffle, GF-Cheddy, home,
    '#FF8A35':
      'invert(20%) sepia(62%) saturate(281%) hue-rotate(16deg) brightness(157%) contrast(90%)', // shopall-smokey
    '#FF5400':
      'invert(33%) sepia(78%) saturate(672%) hue-rotate(0deg) brightness(105%) contrast(105%)', // Variety, Mover, GF-Pasta
    '#FAA819':
      'invert(40%) sepia(150%) saturate(572%) hue-rotate(355deg) brightness(102%) contrast(555%)', // Heels,
    '#F2A5C8':
      'invert(44%) sepia(44%) saturate(500%) hue-rotate(315deg) brightness(165%) contrast(180%)', // Dance
    '#EE4F9C': 'brightness(4) saturate(2) hue-rotate(323deg) sepia(.3)', // Bling Bling
    '#9B7AE0': 'brightness(4) saturate(2) hue-rotate(282deg) contrast(0.25)', // Smokey
    '#6027B4': 'brightness(4) saturate(2) hue-rotate(282deg)', // Vegan
    '#773DBD':
      'invert(38%) sepia(96%) saturate(441%) hue-rotate(572deg) brightness(85%) contrast(196%)', //GF-Vegan
    '#2B38BD': 'brightness(4) saturate(2) hue-rotate(238deg)', // Shella, twist
    '#FFDD04':
      'invert(37%) sepia(89%) saturate(627%) hue-rotate(15deg) brightness(102%) contrast(1000%)', // Pasta,
    '#FFFFBD':
      'invert(17%) sepia(71%) saturate(293%) hue-rotate(357deg) brightness(441%) contrast(85%)', // Shopall-hey-hey
    '#F752AD':
      'invert(42%) sepia(58%) saturate(500%) hue-rotate(240deg) brightness(101%) contrast(293%)', //shop-all-pasta
  }

  return starColorFilter[starColorHex.toUpperCase()]
}
